import CancellationFormComponent from "../components/CancellationForm.component";
import CancellationProcessComponent from "../components/CancellationProcess.component";
import CancellationTestComponent from "../components/CancellationTest.component";

const cancellationRoutes = [
  {
    paths: [
      '/membership-cancellation',
    ],
    exact: true,
    component: CancellationProcessComponent
  },
  {
    paths: [
      '/membership-cancellation-full',
    ],
    exact: true,
    component: CancellationFormComponent
  },
  {
    paths: [
      '/membership-cancellation-test',
    ],
    exact: true,
    component: CancellationTestComponent
  }
]

const routes = cancellationRoutes
  .map(({ paths, ...rest }) => paths.map((path) => ({ path, ...rest })))
  .flat();

export default routes;